import Vue from 'vue'

class CostCenterRepository {

  controller = {}

  search(organizationId, data, instanceId = 'default') {
    return new Promise((resolve, reject) => {

      if(this.controller[instanceId]) {
        this.controller[instanceId].abort()
      }
      this.controller[instanceId] = new AbortController()

      Vue.auth.fetch({
        url: `/api/organization/${organizationId}/cost-center/search`,
        method: 'post',
        data,
        signal: this.controller[instanceId].signal
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  create(organizationId, data) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/organization/${organizationId}/cost-center`,
        method: 'post',
        data,
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  update(organizationId, id, data) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/organization/${organizationId}/cost-center/${id}`,
        method: 'put',
        data,
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  delete(organizationId, id, force = false) {
    return new Promise((resolve, reject) => {
      const url = `/api/organization/${organizationId}/cost-center/${id}${force ? '?force=true' : ''}`
      Vue.auth.fetch({
        url,
        method: 'delete',
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  assign(organizationId, id, data) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/organization/${organizationId}/cost-center/${id}/assign`,
        method: 'post',
        data,
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  unassign(organizationId, id, data) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/organization/${organizationId}/cost-center/${id}/unassign`,
        method: 'post',
        data,
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  updateEntityAllocations(organizationId, entityType, entityId, costCenters) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/organization/${organizationId}/${entityType}/${entityId}/cost-centers`,
        method: 'put',
        data: { costCenters },
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

}

export default new CostCenterRepository()